import { Space, Typography } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import Status from 'app/components/Core/LineItem/Status'
import KDateInfo from 'app/components/Modules/DataDisplay/KDateInfo'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  showDates?: boolean
  showStatus?: boolean
  showCheckupDays?: boolean
}

// used in rental show page -> read only and simple
const BaseItem: React.FC<MemberProps<ILineItem, Props>> = ({
  member,
  props: { showDates, showStatus, showCheckupDays } = {}
}) => {
  const { tCore } = useTranslation({ recordType: RecordType.line_item, scope: 'info' })
  const hasDates = showDates && Boolean(member.start_date && member.return_date)
  const hasStatus = showStatus && Boolean(member.machineStatus)
  const hasCheckupDays = showCheckupDays && Boolean(member.category?.checkupDays)

  return (
    <Space direction="vertical" size={1}>
      <Space direction="vertical">
        <Typography.Text strong>{member.name}</Typography.Text>
        <If condition={member.sub_items?.length}>
          <Typography.Text type="secondary" className="mt-3">
            {member.sub_items
              ?.filter((item) => item.freeAttachment)
              .map((item) => item.name)
              ?.join(', ')}
          </Typography.Text>
        </If>
      </Space>
      <If condition={hasDates || hasStatus || hasCheckupDays}>
        <Space>
          <If condition={hasDates}>
            <KDateInfo dates={member} />
          </If>
          <If condition={hasStatus}>
            <div>
              <Status member={member} />
            </div>
          </If>
          <If condition={hasCheckupDays}>
            <KTag
              color="blue"
              text={tCore({ id: 'checkup_days' }, { days: member.category?.checkupDays })}
            />
          </If>
        </Space>
      </If>
    </Space>
  )
}

export default BaseItem
